import { render, staticRenderFns } from "./SolicitacoesBarTable.vue?vue&type=template&id=73231e3d&scoped=true&"
import script from "./SolicitacoesBarTable.vue?vue&type=script&lang=js&"
export * from "./SolicitacoesBarTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73231e3d",
  null
  
)

export default component.exports